import React, { useState } from "react";
import { Outlet, NavLink, Link, useParams } from "react-router-dom";
import styles from "./Styles/MyNavbar.module.css";
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';

const MyNavbar = () => {
  const { lang } = useParams();
  const [menuOpen, setMenuOpen] = useState(false);

  const { t, i18n } = useTranslation();
  // Change the language dynamically
  React.useEffect(() => {
    i18n.changeLanguage(lang);
  }, [lang, i18n]);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
    // Prevent background scrolling when menu is open
    document.body.classList.toggle("no-scroll", menuOpen);
  };


  //an array that contains all navLinks and their routes
  const navLinks = [
    { text: t('menu.definition'), to: '/definition' },
    { text: t('menu.liste'), to: '/worldlist' },
    { text: t('menu.worldmodel'), to: '/worldmodel' },
    { text: t('menu.konzept'), to: '/concept' },
    { text: t('menu.about'), to: '/about' },
    { text: t('menu.reisen'), to: '/travels' },
    { text: t('menu.buecher'), to: '/book' },
    { text: t('menu.kommentare'), to: '/comments' },
  ];

  return (
    <>
      {/* Logo */}
      <div className={styles.logoContainer}>
        <div>
          <Link to={`/${lang}`}>
            <img
              src="/logo-frankgrosseworldlist.png"
              alt="Frank Grosse World List Logo"
              className={styles.logo}
            />
          </Link>
        </div>
        <div className={styles.navBarContainer}>
          <nav className={styles.navBar}>
            {/* Hamburger Button */}
            <div
              className={styles.hamburgerButton}
              onClick={toggleMenu}
              aria-label="Toggle navigation menu"
            >
              <span className={styles.menuText}>MENU</span>
              <img
                src={menuOpen ? "/close-icon.png" : "/hamburger-icon.png"}
                alt="Menu icon"
                className={styles.hamburgerIcon}
              />
            </div>

            {/* Desktop Nav Links */}
            <div className={styles.navLinks}>
              {/* mapping over navLinks array to dynamically generate navMenu => easier to maintain when removing or adding new links */}
              {navLinks.map((link, index) => (

                <p key={index} className={styles.navLinkItem}>
                  <NavLink
                    className={({ isActive }) =>
                      isActive ? `${styles.navLink} ${styles.linkActive}` : styles.navLink
                    }
                    to={`/${lang}${link.to}`}
                    end
                  >
                    {link.text}
                  </NavLink>
                </p>
              ))}
            </div>
          </nav>
        </div>
        <div style={{width: "fit-content", flexShrink: 0}}>
          <LanguageSwitcher newLang="de" className={styles.langLink} icon={<img src="/de.png" alt="🇩🇪" style={{width: "35px"}}/>} /><br />
          <LanguageSwitcher newLang="en" className={styles.langLink} icon={<img src="/gb.png" alt="🇬🇧" style={{width: "35px"}}/>} />
        </div>
        {/* <div>
          <LanguageSelector />
        </div> */}
      </div>


      {/* Mobile Overlay Menu */}
      <div className={`${styles.overlay} ${menuOpen ? styles.active : ""}`}>
        <ul className={styles.navbarUl}>
          <li className={styles.navLinkItem}>
            <NavLink
              className={({ isActive }) =>
                isActive ? `${styles.navLink} ${styles.linkActive}` : styles.navLink
              }
              to={`/${lang}`}
              onClick={toggleMenu} // Close menu when a link is clicked
              end
            >
              Willkommen
            </NavLink>
          </li>

          {navLinks.map((link, index) => (

            <li key={index} className={styles.navLinkItem}>
              <NavLink
                className={({ isActive }) =>
                  isActive ? `${styles.navLink} ${styles.linkActive}` : styles.navLink
                }
                to={`/${lang}${link.to}`}
                onClick={toggleMenu} // Close menu when a link is clicked
              >
                {link.text}
              </NavLink>
            </li>
          ))}

        </ul>
      </div>

      <Outlet />
    </>
  );
};

export default MyNavbar;
